import { render, staticRenderFns } from "./casesTransfer.vue?vue&type=template&id=a0099fd2&scoped=true"
import script from "./casesTransfer.vue?vue&type=script&lang=js"
export * from "./casesTransfer.vue?vue&type=script&lang=js"
import style0 from "./casesTransfer.vue?vue&type=style&index=0&id=a0099fd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0099fd2",
  null
  
)

export default component.exports